/*
  Contact us modal
  ----------------
  Comportamiento del popup "Contact us" del footer de shop.scania.com, sin jQuery
  ni Magento. Abre con el enlace del footer y cierra con la X, con el boton negro
  "Cerrar", con clic en el overlay y con Escape. Mientras esta abierto atrapa el
  foco dentro del dialogo (los sentinelas focusable-start / focusable-end del
  modal original) y bloquea el scroll del body con body._has-modal.
*/
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function init(root) {
    if (!root || root.dataset.contactModalReady === 'true') return;
    root.dataset.contactModalReady = 'true';

    var dialog = root.querySelector('.modal-popup');
    var innerWrap = root.querySelector('.modal-inner-wrap');
    var start = root.querySelector('[data-role="focusable-start"]');
    var end = root.querySelector('[data-role="focusable-end"]');
    var lastFocused = null;

    function focusables() {
      return Array.prototype.filter.call(innerWrap.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
    }

    function open() {
      if (root.classList.contains('_show')) return;
      lastFocused = document.activeElement;
      root.classList.add('_show');
      document.body.classList.add('_has-modal');

      var items = focusables();
      if (items.length) items[0].focus();
      else dialog.focus();
    }

    function close() {
      if (!root.classList.contains('_show')) return;
      root.classList.remove('_show');
      document.body.classList.remove('_has-modal');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      lastFocused = null;
    }

    // X del header y boton negro "Cerrar" del footer
    root.querySelectorAll('[data-role="closeBtn"], [data-role="action"]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    // Clic en el overlay o fuera de la caja blanca
    root.querySelector('[data-contact-modal-overlay]').addEventListener('click', close);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('_show')) close();
    });

    // Focus trap: los sentinelas devuelven el foco al extremo contrario
    start.addEventListener('focus', function () {
      var items = focusables();
      if (items.length) items[items.length - 1].focus();
    });

    end.addEventListener('focus', function () {
      var items = focusables();
      if (items.length) items[0].focus();
    });

    document.querySelectorAll('[data-contact-modal-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        open();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-contact-modal]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // El editor de temas recarga secciones sin recargar la pagina
  document.addEventListener('shopify:section:load', boot);
})();
